// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview[data-v-1c4fd7a9]{border-radius:.25rem;box-shadow:0 .1rem .25rem 0 #bdbdbd;padding:1.25rem}.preview-row[data-v-1c4fd7a9]{border-bottom:1px solid #e0e0e0;padding:.5rem 0}.preview-row__label[data-v-1c4fd7a9]{color:#9e9e9e}.preview-content[data-v-1c4fd7a9]{font-family:Helvetica,Arial,sans-serif}.preview-content[data-v-1c4fd7a9]  a{color:blue}.preview-content[data-v-1c4fd7a9] >p:last-child{margin-bottom:0}.preview-content[data-v-1c4fd7a9]  img{max-width:100%}", ""]);
// Exports
module.exports = exports;
